import { combineReducers, configureStore } from '@reduxjs/toolkit'
import deviceReducer from '@src/redux/reducer/device.ts'
import gpsReducer from '@src/redux/reducer/gps.ts'
import experienceReducer from '@src/redux/reducer/experience.ts'
import howlerSelector from '@src/redux/reducer/howler.ts'
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux'
import mapBottomTab from '@src/redux/reducer/mapBottomTab.ts'
import mapMarker from '@src/redux/reducer/mapMarker.ts'

const rootReducer = combineReducers({
  experience: experienceReducer,
  device: deviceReducer,
  gps: gpsReducer,
  howler: howlerSelector,
  mapBottomTab: mapBottomTab,
  mapMarkers: mapMarker,
})

export const store = configureStore({
  reducer: rootReducer,
})

export type RootState = ReturnType<typeof rootReducer>
export type AppDispatch = typeof store.dispatch

export const useAppDispatch: () => AppDispatch = useDispatch
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
